export default __webpack_public_path__ + "static/media/loginbg.70c2ae61.jpg";